import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductLogisticGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-logistic-group';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductLogisticGroupRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/product-logistic-group-request';



@Component({
  selector: 'app-product-logistic-group-list',
  templateUrl: './product-logistic-group-list.component.html',
  styleUrls: ['./product-logistic-group-list.component.scss']
})

export class ProductLogisticGroupListComponent extends BasePage2<ProductLogisticGroup> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
// ---------------------------------------------------
productLogisticGroups: ProductLogisticGroup[] = [];
// ---------------------------------------------------

//----------------------------------------------------------------------

constructor(
    protected toastr            : ToastrService,
    protected controlService    : ControlTablesService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService,
    protected location          : Location) {
    super(toastr, router, baseService, leanUtilsService, location);

    this.entityName  = 'productLogisticGroup';
}
//----------------------------------------------------------------------


  
//----------------------------------------------------------------------

listFields = [
    { prop: 'productLogisticGroupCode', name: 'Code',  insertOnly : true},
    { prop: 'name', name: 'Name' },
    { prop: 'rank', name: 'Rang' },
]
//----------------------------------------------------------------------

//----------------------------------------------------------------------

getRows(): ProductLogisticGroup[] {
    return this.productLogisticGroups;
}

//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
    let entity : ProductLogisticGroup = new ProductLogisticGroup();
    entity.inserted = true;
    entity.edit = true;
    this.productLogisticGroups.push(entity);
    this.productLogisticGroups = [...this.productLogisticGroups];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(productLogisticGroup : ProductLogisticGroup ): Promise<ProductLogisticGroup> {
    let request  : ProductLogisticGroupRequest = new ProductLogisticGroupRequest(this.controlService.getUserInfo());
    request.productLogisticGroup = productLogisticGroup;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------
  
//----------------------------------------------------------------------
loadData() {
let request         : BaseRequest = this.controlService.getRequest();
request.strArg1 = this.code;
request.strArg2 = this.name;

this.controlService.getList(this.entityName, request).then(result => {
    this.productLogisticGroups = result;  
})
}  
//----------------------------------------------------------------------

}


